import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

const root = "_root_17gz2_1";
const styles = {
	root: root
};

const Menu = (_a) => {
  var { children, className, role } = _a, props = __rest(_a, ["children", "className", "role"]);
  return jsx("ul", { role, "aria-label": props["aria-label"], className: clsx(styles.root, className), "data-zds": true, children });
};

export { Menu };
//# sourceMappingURL=Menu.es.js.map
